import { DefaultState } from '@src/redux/types'

import {
  ASSESSMENT,
  ASSESSMENT_ATTEMPT,
  ASSESSMENT_ATTEMPT_DELETE,
  ASSESSMENT_ATTEMPT_ITEM,
  ASSESSMENT_BULK,
  ASSESSMENT_COPY,
  ASSESSMENT_CREATE,
  ASSESSMENT_CRITERIA,
  ASSESSMENT_CRITERIA_LIST,
  ASSESSMENT_CRITERIA_STATUS,
  ASSESSMENT_CRITERIA_TYPES,
  ASSESSMENT_CRITERIA_UPDATE,
  ASSESSMENT_DELETE,
  ASSESSMENT_LIST,
  ASSESSMENT_STUDENT,
  ASSESSMENT_STUDENT_CRITERIA_DETAILS,
  ASSESSMENT_STUDENT_UPDATED,
  ASSESSMENT_STUDENT_UPLOAD,
  ASSESSMENT_SUBMIT,
} from '../constants/actionTypes'
import * as API from '../constants/api'

export const defaultState = () => ({ data: null, loading: false, error: null })

export const initialState: () => {
  [ASSESSMENT]: DefaultState<`${typeof API.ASSESSMENT}`, 'get'>
  [ASSESSMENT_ATTEMPT]: DefaultState<`${typeof API.ASSESSMENT_ATTEMPT}`, 'post'>
  [ASSESSMENT_ATTEMPT_DELETE]: DefaultState<`${typeof API.ASSESSMENT_ATTEMPT}`, 'delete'>
  [ASSESSMENT_ATTEMPT_ITEM]: DefaultState<`${typeof API.ASSESSMENT_ATTEMPT}`, 'get'>
  [ASSESSMENT_BULK]: DefaultState<`${typeof API.ASSESSMENT_BULK}`, 'post'>
  [ASSESSMENT_COPY]: DefaultState<`${typeof API.ASSESSMENT_COPY}`, 'post'>
  [ASSESSMENT_CREATE]: DefaultState<`${typeof API.ASSESSMENT}`, 'post'>
  [ASSESSMENT_CRITERIA]: DefaultState<`${typeof API.ASSESSMENT_CRITERIA}`, 'post'>
  [ASSESSMENT_CRITERIA_LIST]: DefaultState<`${typeof API.ASSESSMENT_CRITERIA_LIST}`, 'get'>
  [ASSESSMENT_CRITERIA_STATUS]: DefaultState<`${typeof API.ASSESSMENT_CRITERIA_STATUS}`, 'get'>
  [ASSESSMENT_CRITERIA_TYPES]: DefaultState<`${typeof API.ASSESSMENT_CRITERIA_TYPES}`, 'get'>
  [ASSESSMENT_CRITERIA_UPDATE]: DefaultState<`${typeof API.ASSESSMENT_CRITERIA}`, 'post'>
  [ASSESSMENT_DELETE]: DefaultState<`${typeof API.ASSESSMENT_ATTEMPT}`, 'delete'>
  [ASSESSMENT_LIST]: DefaultState<`${typeof API.ASSESSMENT}`, 'get'>
  [ASSESSMENT_STUDENT]: DefaultState<`${typeof API.ASSESSMENT_STUDENT}`, 'get'>
  [ASSESSMENT_STUDENT_UPDATED]: DefaultState<`${typeof API.ASSESSMENT_STUDENT_UPDATED}`, 'get'>
  [ASSESSMENT_STUDENT_CRITERIA_DETAILS]: DefaultState<`${typeof API.ASSESSMENT_STUDENT_CRITERIA_DETAILS}`, 'get'>
  [ASSESSMENT_STUDENT_UPLOAD]: DefaultState<`${typeof API.ASSESSMENT_STUDENT_UPLOAD}`, 'post'>
  [ASSESSMENT_SUBMIT]: DefaultState<`${typeof API.ASSESSMENT_SUBMIT}`, 'post'>
} = () => ({
  [ASSESSMENT]: defaultState(),
  [ASSESSMENT_ATTEMPT]: defaultState(),
  [ASSESSMENT_ATTEMPT_DELETE]: defaultState(),
  [ASSESSMENT_ATTEMPT_ITEM]: defaultState(),
  [ASSESSMENT_BULK]: defaultState(),
  [ASSESSMENT_COPY]: defaultState(),
  [ASSESSMENT_CREATE]: defaultState(),
  [ASSESSMENT_CRITERIA]: defaultState(),
  [ASSESSMENT_CRITERIA_LIST]: defaultState(),
  [ASSESSMENT_CRITERIA_STATUS]: defaultState(),
  [ASSESSMENT_CRITERIA_TYPES]: defaultState(),
  [ASSESSMENT_CRITERIA_UPDATE]: defaultState(),
  [ASSESSMENT_DELETE]: defaultState(),
  [ASSESSMENT_LIST]: defaultState(),
  [ASSESSMENT_STUDENT]: defaultState(),
  [ASSESSMENT_STUDENT_UPDATED]: defaultState(),
  [ASSESSMENT_STUDENT_CRITERIA_DETAILS]: defaultState(),
  [ASSESSMENT_STUDENT_UPLOAD]: defaultState(),
  [ASSESSMENT_SUBMIT]: defaultState(),
})
